// Mocked until the styles step exists (product decision: Styles is skipped).
export const ALPHA_MOCKED_STYLES = ["Bold", "Premium", "Authentic"] as const;
